import { capitalizeTerm } from "@loot-os/api-contract";

import { useTerminology } from "../../../../lib/terminology.js";
import type { TemplateLink } from "../../shared/links.js";

export interface BoxesBreadcrumbContent {
  /** The pages above this one, outermost first. */
  trail: Array<TemplateLink & { label: string }>;
  current: string;
}

export interface BoxesTitleContent {
  text: string;
}

/** Where the boxes page sits: under the home page. */
export function useBoxesBreadcrumbContent(): BoxesBreadcrumbContent {
  const { box } = useTerminology();
  return { trail: [{ label: "Home", to: "/" }], current: capitalizeTerm(box.plural) };
}

/** The page's heading, in the store's word for its boxes. */
export function useBoxesTitleContent(): BoxesTitleContent {
  const { box } = useTerminology();
  return { text: capitalizeTerm(box.plural) };
}
